<!-- Placeholder View -->
<div class="placeholder-box" *ngIf="!showForm">
  <div class="add-box">
    <button type="button" class="create-quest-button" (click)="onCreateQuestClick()">
      <span class="plus">+</span>
      <p>Click Here to Create New Quest</p>
    </button>
  </div>

  <!-- Recently Created Quests -->
  <div class="recent-section" *ngIf="allQuests.length">
    <div class="recent-header">
      <h2 class="recent-title">Recently Created Quest</h2>
      <button
        type="button"
        class="view-all-btn"
        (click)="showAllQuests = !showAllQuests"
      >
        {{ showAllQuests ? 'View Less' : 'View All' }}
      </button>
    </div>

    <!-- Search Field -->
    <div class="search-container">
      <input
        type="text"
        class="quest-search-input"
        placeholder="Search by quest name..."
        [(ngModel)]="questSearchQuery"
      />
    </div>

    <div
      class="quest-card"
      *ngFor="let quest of filteredQuests"
    >
      <div class="quest-thumbnail">
        <img
          *ngIf="quest.thumbnail"
          [src]="quest.thumbnail"
          [alt]="quest.name"
        />
      </div>
      <div class="quest-info">
        <div class="quest-title">{{ quest.name }}</div>
        <div class="quest-description">
          {{ quest.shortDescription }}
        </div>
        <div class="quest-meta">
          <span class="quest-sessions">
            {{ quest.sessions?.length || 0 }} Sessions
          </span>
          <span class="quest-created">
            Created on:
            {{ quest.createdDateTime | date: 'MMMM d, y' }}
          </span>
        </div>
      </div>
      <div class="quest-actions">
        <button
          type="button"
          class="publish-toggle-btn"
          [ngClass]="isQuestPublished(quest) ? 'published' : 'draft'"
          (click)="onToggleQuestPublish(quest)"
          [disabled]="publishingQuestId === (quest.id || quest._id)"
        >
          {{ isQuestPublished(quest) ? 'Back to Draft' : 'Publish to All' }}
        </button>
        <button type="button" class="quest-edit-btn" (click)="onEditQuestClick(quest.id || quest._id)">
          <img src="assets/img/edit 1.png" alt="Edit quest" class="edit-icon" />
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Validation Modal -->
<div class="validation-modal-backdrop" *ngIf="showValidationModal">
  <div class="validation-modal">
    <h3 class="validation-title">Please fill all required fields</h3>
    <ul class="validation-list">
      <li *ngFor="let err of validationErrors">{{ err }}</li>
    </ul>
    <button
      type="button"
      class="validation-ok-button"
      (click)="showValidationModal = false"
    >
      OK
    </button>
  </div>
</div>

<!-- Publish Confirmation Modal -->
<div class="validation-modal-backdrop" *ngIf="showPublishConfirmModal" (click)="closePublishConfirmModal()">
  <div class="validation-modal" (click)="$event.stopPropagation()">
    <div class="validation-modal-header">
      <h3 class="validation-modal-title">Confirm Action</h3>
      <button type="button" class="validation-modal-close" (click)="closePublishConfirmModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="validation-modal-body">
      <p class="publish-confirm-message">
        {{ isPublishing 
          ? 'Do you want to publish this quest "' + (questToPublish?.name || '') + '" to all the members?' 
          : 'Do you want to keep this quest "' + (questToPublish?.name || '') + '" as draft or don\'t want to publish to all the members?' }}
      </p>
    </div>
    <div class="validation-modal-footer">
      <button type="button" class="validation-modal-cancel-btn" (click)="closePublishConfirmModal()">
        Cancel
      </button>
      <button type="button" class="validation-modal-ok-btn" (click)="confirmPublishQuest()">
        Confirm
      </button>
    </div>
  </div>
</div>

<!-- Success Modal -->
<div class="validation-modal-backdrop" *ngIf="showSuccessModal">
  <div class="validation-modal success-modal">
    <h3 class="validation-title success-title">
      {{ isEditMode ? 'Quest updated successfully!' : 'Quest saved successfully!' }}
    </h3>
    <p class="success-message">
      {{ isEditMode ? 'Your quest has been updated and saved.' : 'Your quest has been created and saved.' }}
    </p>
    <button
      type="button"
      class="validation-ok-button"
      (click)="onSuccessModalOk()"
    >
      OK
    </button>
  </div>
</div>

<!-- Preview Modal -->
<div class="validation-modal-backdrop" *ngIf="showPreviewModal" (click)="closePreviewModal()">
  <div class="preview-modal" (click)="$event.stopPropagation()">
    <div class="preview-modal-header">
      <h2 class="preview-modal-title">Quest Preview</h2>
      <button type="button" class="preview-modal-close" (click)="closePreviewModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="preview-modal-content">
      <!-- Quest Name and Description -->
      <div class="preview-section" *ngIf="questName || questDescription">
        <h3 class="preview-section-title">Quest Name: {{ questName }}</h3>
        <p class="preview-text" *ngIf="questDescription">{{ questDescription }}</p>
      </div>

      <!-- Quest Image -->
      <div class="preview-section" *ngIf="getPreviewImageUrl(questImageFile, questImagePreview)">
        <h3 class="preview-section-title">Quest Image</h3>
        <img [src]="getPreviewImageUrl(questImageFile, questImagePreview)" alt="Quest image" class="preview-image-large" />
      </div>

      <!-- Introduction -->
      <div class="preview-section" *ngIf="introductionDescription || getPreviewImageUrl(introductionImageFile, introductionImagePreview) || introductionAudioFile || introductionAudioUrl">
        <h3 class="preview-section-title">Introduction</h3>
        <p class="preview-text" *ngIf="introductionDescription">{{ introductionDescription }}</p>
        
        <!-- Introduction Image -->
        <div *ngIf="getPreviewImageUrl(introductionImageFile, introductionImagePreview)" class="preview-image-container">
          <img [src]="getPreviewImageUrl(introductionImageFile, introductionImagePreview)" alt="Introduction image" class="preview-image-medium" />
        </div>

        <!-- Introduction Audio -->
        <div *ngIf="getAudioUrl(introductionAudioFile, introductionAudioUrl, 'intro')" class="preview-audio-container">
          <div class="audio-player">
            <button 
              mat-icon-button 
              class="play-pause-btn"
              (click)="toggleAudio(getAudioUrl(introductionAudioFile, introductionAudioUrl, 'intro'), 'intro')"
              [attr.aria-label]="isAudioPlaying('intro') ? 'Pause' : 'Play'">
              <mat-icon>{{ isAudioPlaying('intro') ? 'pause' : 'play_arrow' }}</mat-icon>
            </button>
            <div class="audio-waveform" [class.playing]="isAudioPlaying('intro')">
              <div class="waveform-bar" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34]"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sessions -->
      <div class="preview-section" *ngFor="let session of sessions; let i = index">
        <h3 class="preview-section-title">Session {{ i + 1 }}: {{ session.heading }}</h3>
        <p class="preview-text" *ngIf="session.description">{{ session.description }}</p>

        <!-- Session Image -->
        <div *ngIf="getSessionPreviewImage(session)" class="preview-image-container">
          <img [src]="getSessionPreviewImage(session)" alt="Session image" class="preview-image-medium" />
        </div>

        <!-- Session Audio -->
        <div *ngIf="getSessionAudioUrl(session)" class="preview-audio-container">
          <div class="audio-player">
            <button 
              mat-icon-button 
              class="play-pause-btn"
              (click)="toggleAudio(getSessionAudioUrl(session), 'session-' + session.id)"
              [attr.aria-label]="isAudioPlaying('session-' + session.id) ? 'Pause' : 'Play'">
              <mat-icon>{{ isAudioPlaying('session-' + session.id) ? 'pause' : 'play_arrow' }}</mat-icon>
            </button>
            <div class="audio-waveform" [class.playing]="isAudioPlaying('session-' + session.id)">
              <div class="waveform-bar" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34]"></div>
            </div>
          </div>
        </div>

        <!-- Session Tasks -->
        <div *ngIf="session.tasks && session.tasks.length > 0" class="preview-tasks">
          <h4 class="preview-tasks-title">Tasks:</h4>
          <ul class="preview-tasks-list">
            <li *ngFor="let task of session.tasks" class="preview-task-item">{{ task }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="preview-modal-footer">
      <button type="button" class="preview-close-btn" (click)="closePreviewModal()">
        Close
      </button>
    </div>
  </div>
</div>

<!-- Quest Creation Form -->
<div class="quest-form-container" *ngIf="showForm">
  <!-- Header with Back and Save buttons -->
  <div class="form-header">
    <button type="button" class="back-button" (click)="onBackClick()">
      <span class="back-arrow">←</span>
      <span class="back-text">Back</span>
    </button>
    <div class="header-buttons">
      <button type="button" class="preview-button" (click)="openPreviewModal()">
        Preview
      </button>
      <button type="button" class="save-quest-button" (click)="saveQuest()">
        {{ isEditMode ? 'Update Quest' : 'Save Quest' }}
      </button>
    </div>
  </div>

  <!-- Dashboard Card Section -->
  <div class="dashboard-card-section">
    <h2 class="section-title">Dashboard Card Section</h2>
    
    <div class="form-group">
      <label for="questName" class="form-label">Quest Name</label>
      <input
        type="text"
        id="questName"
        [(ngModel)]="questName"
        name="questName"
        class="form-control"
        placeholder="Quest Name"
      />
    </div>

    <div class="form-group">
      <label for="questDescription" class="form-label">Quest Description</label>
      <textarea
        id="questDescription"
        [(ngModel)]="questDescription"
        name="questDescription"
        class="form-control"
        rows="4"
        placeholder="Quest Description"
      ></textarea>
    </div>

    <div class="form-group">
      <div class="image-upload-container">
        <div class="image-upload-box">
          <input
            type="file"
            id="questImage"
            accept="image/*"
            (change)="onQuestImageSelected($event)"
            style="display: none;"
          />
          <label for="questImage" class="image-upload-label">
            <img
              *ngIf="!questImagePreview"
              src="assets/img/image 1.png"
              alt="Upload image"
              class="upload-image-icon"
            />
            <img
              *ngIf="questImagePreview"
              [src]="questImagePreview"
              class="preview-image"
            />
            <span *ngIf="!questImagePreview">Click here to upload the image</span>
          </label>
        </div>
        <div class="image-dimensions">
          <p>The dimension of the image should be Width: 100 px & Height: 108 px</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Quest Journey Section -->
  <div class="quest-journey-section">
    <h2 class="section-title">Quest Journey</h2>

    <!-- Introduction Card -->
    <div class="journey-card">
      <div class="journey-card-header" (click)="toggleIntroduction()">
        <h3 class="journey-card-title">Introduction</h3>
        <mat-icon [class.rotated]="introductionExpanded">keyboard_arrow_down</mat-icon>
      </div>
      <div class="journey-card-content" *ngIf="introductionExpanded">
        <div class="form-group">
          <label for="introductionDescription" class="form-label">Description</label>
          <textarea
            id="introductionDescription"
            [(ngModel)]="introductionDescription"
            name="introductionDescription"
            class="form-control"
            rows="4"
            placeholder="Description"
          ></textarea>
        </div>

        <div class="form-group">
          <div class="media-row">
            <div class="image-upload-container">
              <div class="image-upload-box">
                <input
                  type="file"
                  id="introductionImage"
                  accept="image/*"
                  (change)="onIntroductionImageSelected($event)"
                  style="display: none;"
                />
                <label for="introductionImage" class="image-upload-label">
                  <img
                    *ngIf="!introductionImagePreview"
                    src="assets/img/image 1.png"
                    alt="Upload image"
                    class="upload-image-icon"
                  />
                  <img
                    *ngIf="introductionImagePreview"
                    [src]="introductionImagePreview"
                    class="preview-image"
                  />
                  <span *ngIf="!introductionImagePreview">Click here to upload the image</span>
                </label>
              </div>
              <div class="image-dimensions">
                <p>The dimension of the image should be Width: 100 px & Height: 94 px</p>
              </div>
            </div>

            <div class="image-upload-container">
              <div class="image-upload-box">
                <input
                  type="file"
                  id="introductionAudio"
                  accept="audio/*"
                  (change)="onIntroductionAudioSelected($event)"
                  style="display: none;"
                />
                <label for="introductionAudio" class="image-upload-label">
                  <img
                    src="assets/img/music-file 1.png"
                    alt="Upload audio"
                    class="upload-audio-icon"
                  />
                  <span>{{ introductionAudioName || 'Click here to upload the File' }}</span>
                </label>
              </div>
              <div class="image-dimensions">
                <p>Introduction Audio: Upload an audio file for the introduction</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sessions Cards -->
    <div class="journey-card" *ngFor="let session of sessions; let sessionIndex = index">
      <div class="journey-card-header">
        <h3 class="journey-card-title" (click)="toggleSession(session.id)">
          Session {{ sessionIndex + 1 }}
        </h3>
        <div class="session-header-actions">
          <mat-icon
            [class.rotated]="session.isExpanded"
            (click)="toggleSession(session.id)"
          >
            keyboard_arrow_down
          </mat-icon>
          <button
            type="button"
            class="remove-session-button"
            *ngIf="sessions.length > 1"
            (click)="removeSession(session.id); $event.stopPropagation()"
            title="Remove Session"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <div class="journey-card-content" *ngIf="session.isExpanded">
        <div class="form-group">
          <label [for]="'sessionHeading' + session.id" class="form-label">Session Heading</label>
          <input
            type="text"
            [id]="'sessionHeading' + session.id"
            [(ngModel)]="session.heading"
            [name]="'sessionHeading' + session.id"
            class="form-control"
            placeholder="Session Heading"
          />
        </div>

        <div class="form-group">
          <label [for]="'sessionDescription' + session.id" class="form-label">Session Description</label>
          <textarea
            [id]="'sessionDescription' + session.id"
            [(ngModel)]="session.description"
            [name]="'sessionDescription' + session.id"
            class="form-control"
            rows="4"
            placeholder="Session Description"
          ></textarea>
        </div>

        <div class="form-group">
          <div class="media-row">
            <div class="image-upload-container">
              <div class="image-upload-box">
                <input
                  type="file"
                  [id]="'sessionImage' + session.id"
                  accept="image/*"
                  (change)="onSessionImageSelected($event, session.id)"
                  style="display: none;"
                />
                <label [for]="'sessionImage' + session.id" class="image-upload-label">
                  <img
                    *ngIf="!session.image"
                    src="assets/img/image 1.png"
                    alt="Upload image"
                    class="upload-image-icon"
                  />
                  <img
                    *ngIf="session.image"
                    [src]="session.image"
                    class="preview-image"
                  />
                  <span *ngIf="!session.image">Click here to upload the image</span>
                </label>
              </div>
              <div class="image-dimensions">
                <p>Session Image: The dimension of the image should be Width: 100 px & Height: 94 px</p>
              </div>
            </div>

            <div class="image-upload-container">
              <div class="image-upload-box">
                <input
                  type="file"
                  [id]="'sessionAudio' + session.id"
                  accept="audio/*"
                  (change)="onSessionAudioSelected($event, session.id)"
                  style="display: none;"
                />
                <label [for]="'sessionAudio' + session.id" class="image-upload-label">
                  <img
                    src="assets/img/music-file 1.png"
                    alt="Upload audio"
                    class="upload-audio-icon"
                  />
                  <span>{{ session.audio || 'Click here to upload the File' }}</span>
                </label>
              </div>
              <div class="image-dimensions">
                <p>Session Audio: Upload an audio file for this session</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Tasks Section -->
        <div class="tasks-section">
          <h4 class="tasks-title">Tasks</h4>
          <div
            class="task-item"
            *ngFor="let task of session.tasks; let i = index; trackBy: trackTask"
          >
            <input
              type="text"
              [(ngModel)]="session.tasks[i]"
              [name]="'task' + session.id + '_' + i"
              class="form-control task-input"
              [placeholder]="'Task ' + (i + 1)"
            />
            <button
              type="button"
              class="add-task-button"
              (click)="addTask(session.id)"
              *ngIf="i === session.tasks.length - 1"
            >
              <mat-icon>add</mat-icon>
            </button>
            <button
              type="button"
              class="remove-task-button"
              (click)="removeTask(session.id, i)"
              *ngIf="session.tasks.length > 1"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Sessions Button -->
    <button type="button" class="add-sessions-button" (click)="addSession()">
      Add Sessions
    </button>
  </div>
</div>

<!-- Full Screen Loader -->
<div class="full-screen-loader-backdrop" *ngIf="isSaving">
  <div class="full-screen-loader">
    <div class="full-screen-loader-spinner"></div>
    <p class="full-screen-loader-text">
      {{ isEditMode ? 'Updating quest, please wait...' : 'Creating quest, please wait...' }}
    </p>
  </div>
</div>
